var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from "aurelia-templating";
import { autoinject } from "aurelia-dependency-injection";
var TextArea = /** @class */ (function () {
    function TextArea(element) {
        this.element = element;
        this.rows = 1;
        this.info = "";
        this.placeholder = "";
    }
    TextArea.prototype.valueChanged = function () {
        var changeTextEvent = new CustomEvent("text-changed", { bubbles: true });
        this.element.dispatchEvent(changeTextEvent);
    };
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], TextArea.prototype, "rows", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], TextArea.prototype, "maxRows", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextArea.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextArea.prototype, "value", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextArea.prototype, "info", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextArea.prototype, "placeholder", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TextArea.prototype, "resizeable", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TextArea.prototype, "readonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TextArea.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], TextArea.prototype, "tab", void 0);
    TextArea = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Element])
    ], TextArea);
    return TextArea;
}());
export { TextArea };
